import React from 'react';
import { ArrowLeft, Save, Copy, Trash2, Loader2 } from 'lucide-react';

const FormHeader = ({ 
  title, 
  id, 
  isValid, 
  isSubmitting, 
  network, 
  onBack, 
  onClone, 
  onDelete 
}) => {
  return (
    <div className="mb-6">
      <div className="flex items-center gap-4 mb-4">
        <button
          onClick={onBack}
          className="inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 border border-input bg-background hover:bg-accent hover:text-accent-foreground h-9 w-9 p-0"
        >
          <ArrowLeft className="h-4 w-4" />
        </button>
        <div>
          <h1 className="text-2xl font-bold tracking-tight">{title}</h1>
          <p className="text-muted-foreground">
            {id ? 'Edite as configurações da rede de afiliados' : 'Configure uma nova rede de afiliados'}
          </p>
        </div>
      </div>
      
      {/* Barra de ações */}
      <div className="flex gap-2">
        <button
          type="submit"
          form="networkForm"
          disabled={!isValid || isSubmitting}
          className="inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary text-primary-foreground hover:bg-primary/90 h-9 px-4 py-2"
        >
          {isSubmitting ? (
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
          ) : (
            <Save className="mr-2 h-4 w-4" />
          )}
          {isSubmitting ? 'Salvando...' : 'Salvar'}
        </button>
        
        {network && (
          <>
            <button
              onClick={onClone}
              className="inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 border border-input bg-background hover:bg-accent hover:text-accent-foreground h-9 px-4 py-2"
            >
              <Copy className="mr-2 h-4 w-4" />
              Clonar
            </button>
            
            <button
              onClick={onDelete}
              className="inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 border border-destructive bg-background hover:bg-destructive hover:text-destructive-foreground h-9 px-4 py-2"
            >
              <Trash2 className="mr-2 h-4 w-4" />
              Excluir
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default FormHeader;